import React from 'react';
import { Row, Form } from 'react-bootstrap';
import Tags from 'components/common/Tags/Tags';
import Dropdowns from 'components/common/Dropdowns/Dropdowns';
import styles from './LimitationSet.module.scss';
import i18n from 'i18next';
import classnames from 'classnames/bind';
import _ from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

const cx = classnames.bind(styles);

const LimitationSet: React.FC<any> = ({
  title,
  value,
  onChange,
  deleteLimitation,
  changeOperate,
  operate,
  add,
  type,
  needShow,
  titleHint,
  preComment,
  postComment,
  errorTip,
  i18nPrefix,
  disable,
  disableReason,
  supportOperates,
  tipsConfig,
  showPlus = true,
  showClearButton = false,
  cannotChangeOperation,
  formatter,
  healthGetter,
  ...props
}) => {
  if (value.length <= 0 && !needShow) {
    return null;
  }
  const valueWithI18n = i18nPrefix
    ? value.map((option) => {
        const i18nKeyRule1 = `${i18nPrefix}.${option.value.toString().toLowerCase().replace(/-|\s/g, '_')}`;
        const i18nKeyRule2 = `${i18nPrefix}.${option.value.toString()}`;
        return {
          ...option,
          label: i18n.exists(i18nKeyRule1)
            ? i18n.t(i18nKeyRule1)
            : i18n.exists(i18nKeyRule2)
              ? i18n.t(i18nKeyRule2)
              : option.label
        };
      })
    : formatter
      ? value.map((option) => ({
          ...option,
          label: formatter(option.value)
        }))
      : value;
  // ECOPD-5255: decorate chips with outdoor operational status so Tags can
  // color/sort them and the tooltip can render the status details.
  const valueWithHealth = healthGetter
    ? valueWithI18n.map((option) => {
        const health = healthGetter(option);
        return health
          ? {
              ...option,
              healthState: health.state,
              healthReason: health.reason,
              healthSpaceName: health.spaceName,
              healthLastSyncedAt: health.lastSyncedAt,
              healthDeleted: health.deleted
            }
          : option;
      })
    : valueWithI18n;
  const handleOnChange = (choosedValueWithHealth) => {
    const choosedValue = _.intersectionWith(
      value,
      choosedValueWithHealth,
      (option: SelectOptions, optionWithHealth: SelectOptions) =>
        option.value === optionWithHealth.value
    );
    onChange(choosedValue);
  };
  const dropdownHidden = needShow;
  const className = cx('limitationSet', props.className, type);
  const tagsClassName = cx('tags', {
    hasError: errorTip !== undefined
  });
  return (
    <div className={className}>
      {preComment}
      <Form.Group as={Row} controlId={title}>
        <div className={styles.titleArea}>
          <Form.Label>{i18n.t(title)}</Form.Label>
          {titleHint}
        </div>
        <Tags
          value={valueWithHealth}
          onChange={handleOnChange}
          operate={operate}
          addAction={add}
          className={tagsClassName}
          showPlus={showPlus}
          disabled={disable}
          disableReason={disableReason}
          tipsConfig={tipsConfig}
        />
        {showClearButton && !disable && (
          <FontAwesomeIcon
            className={styles.clearBtn}
            icon={faTimes}
            onClick={deleteLimitation}
          />
        )}
        {dropdownHidden || disable ? (
          <div className={styles.emptySpace} />
        ) : (
          <Dropdowns
            deleteLimitation={deleteLimitation}
            changeOperate={cannotChangeOperation ? undefined : changeOperate}
            type={type}
            operate={operate}
            supportOperates={supportOperates}
          />
        )}
      </Form.Group>
      {postComment}
      {errorTip}
    </div>
  );
};

export default LimitationSet;
